let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("2vh0p")).then(() => parcelRequire('lGnF5'));